module.exports = __webpack_public_path__ + "static/media/beach-me-1100.41584997.jpg";